module.exports = __webpack_public_path__ + "img/M.53d89bb5.jpg";